import { useQuery } from "react-query";
import { zodParseWithLog } from "src/api/apiErrorLogs";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { z } from "zod";
import { Post, PostSchema } from "../../post/postSchema";

export const getAllActionPlanActionsKey = "getAllActionPlanActions" as const;

type Options = {
    actionPlanID: string | undefined;
};
export const useGetAllActionPlanActions = (options: Options) => {
    const { actionPlanID } = options;

    const query = useQuery({
        queryKey: [getAllActionPlanActionsKey],
        enabled: actionPlanID !== undefined,
        queryFn: async () => {
            const url = `/api/action_plans/${actionPlanID}/actions`;

            const response = await loggedInApiCall.get(url, {
                params: {
                    itemsPerPage: 20000,
                },
            });
            return response;
        },
        select: (resp) => {
            const data = resp.data["hydra:member"];
            const validatedData = zodParseWithLog(data, ActionPlanActionSchema.array(), getAllActionPlanActionsKey);
            return validatedData;
        },
    });

    return query;
};

type PostWithoutScores = Pick<Post, "id" | "campaign" | "elements">;
const PostWithoutScoresSchema = PostSchema.pick({
    id: true,
    campaign: true,
    elements: true,
});

export type ActionPlanAction = {
    id: string;
    actionPlan: ActionPlan;
    actionId: number;
    startSimulationSsqPost: PostWithoutScores;
    endSimulationSsqPost: PostWithoutScores;
    type?: string;
    userMessageTitle?: string;
    userMessageBody?: string;
};

const ActionPlanActionSchema: z.ZodType<ActionPlanAction> = z.object({
    id: z.string(),
    actionPlan: z.string(),
    actionId: z.number(),
    startSimulationSsqPost: PostWithoutScoresSchema,
    endSimulationSsqPost: PostWithoutScoresSchema,
    type: z.string().optional(),
    userMessageTitle: z.string().optional(),
    userMessageBody: z.string().optional(),
});

type ActionPlan = IRI;
